document.addEventListener('DOMContentLoaded', () => {
    const svgwrapper = document.getElementsByClassName('svg-wrapper');
    const pictureElement = document.querySelector('.column.column--image picture');
    const imgElement = document.querySelector('.column.column--image img');
  
    if (window.location.pathname === '/') {
        svgwrapper[0].style.display = "block";  
        pictureElement.style.display = "none";  
        imgElement.style.display = "none";  
    } else {
        svgwrapper[0].style.display = "none";  
        pictureElement.style.display = "block";  
        imgElement.style.display = "block";  
    }
  });
  